module.exports = __webpack_public_path__ + "static/light-65549f44130b4cae29d820345d2254ed.png";